// LOP - Product cards: group by custom.style (Style ID) and render color swatches
(function () {
  'use strict';

  var enabled = window.theme && window.theme.settings && window.theme.settings.enable_related_by_style;
  if (!enabled) return;

  var shared = window.LOPStyleSwatchOrder || {};
  var styleGroups = {};
  var productSnapshots = {};

  var CARD_ATTRS = [
    'data-handle',
    'data-product-handle',
    'data-product-url',
    'data-product-image',
    'data-product-title',
    'data-product-color',
    'data-swatch-bg',
    'data-current-variant-id',
    'data-lop-listing-variant-id',
    'data-lop-listing-price-cents',
    'data-lop-listing-compare-at-cents',
    'data-lop-current-color',
    'data-lop-show-memorial-day-sale',
  ];

  function escapeHtml(str) {
    if (shared.escapeHtml) return shared.escapeHtml(str);
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function buildSnapshotFromEmbedded(item) {
    var attrs = {
      'data-handle': item.handle || '',
      'data-product-handle': item.handle || '',
      'data-product-url': item.url || '',
      'data-product-image': item.imageThumb || '',
      'data-product-title': item.title || '',
      'data-product-color': item.color || '',
      'data-swatch-bg': item.swatchBg || '',
      'data-current-variant-id': item.variantId ? String(item.variantId) : '',
    };

    return {
      handle: item.handle,
      media: { type: 'simple', secondImageHtml: '', hasSecondImage: false },
      imageSrc: item.imageSrc || '',
      imageSrc2: item.imageSrc2 || '',
      imageSrc2Alt: item.imageSrc2Alt || '',
      imageSrcset: '',
      imageSizes: '',
      imageAlt: item.imageAlt || item.title || '',
      imageLinkHref: item.url || '',
      imageLinkLabel: item.title || '',
      titleLinkHref: item.url || '',
      titleText: item.title || '',
      priceHtml: item.priceHtml || '',
      variantId: item.variantId ? String(item.variantId) : '',
      badges: item.badges || null,
      label: item.label || null,
      attributes: attrs,
    };
  }

  function parseStyleSiblingsFromCard(card) {
    var script = card.querySelector('script.lop-style-siblings-data');
    if (shared.parseSiblingsFromScript) return shared.parseSiblingsFromScript(script);
    if (!script || !script.textContent) return [];

    try {
      var parsed = JSON.parse(script.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function sortGroupByHandle(group) {
    if (shared.sortSiblings) return shared.sortSiblings(group);
    return group.slice().sort(function (a, b) {
      return String(a.handle).localeCompare(String(b.handle));
    });
  }

  function getSortIndexFromEmbedded(card, handle) {
    var siblings = parseStyleSiblingsFromCard(card);
    for (var i = 0; i < siblings.length; i++) {
      if (siblings[i].handle === handle && typeof siblings[i].sortIndex === 'number') {
        return siblings[i].sortIndex;
      }
    }
    return undefined;
  }

  function registerEmbeddedSiblings(card, idMap) {
    var styleId = card.getAttribute('data-style-id');
    if (!styleId) return;

    var siblings = parseStyleSiblingsFromCard(card);
    if (!siblings.length) return;

    if (!idMap[styleId]) {
      idMap[styleId] = {};
    }

    siblings.forEach(function (item) {
      if (!item || !item.handle) return;

      if (!idMap[styleId][item.handle]) {
        var snap = buildSnapshotFromEmbedded(item);

        idMap[styleId][item.handle] = {
          handle: item.handle,
          image: item.imageThumb || item.imageSrc || '',
          url: item.url || '',
          title: item.title || '',
          color: item.color || '',
          swatchBg: item.swatchBg || '',
          sortIndex: typeof item.sortIndex === 'number' ? item.sortIndex : undefined,
          snapshot: snap,
          embedded: true,
        };
      } else if (typeof item.sortIndex === 'number') {
        idMap[styleId][item.handle].sortIndex = item.sortIndex;
      }
    });
  }

  function getOverflowTemplate(card) {
    var inline = card.querySelector('.product-item__swatches-inline');
    return (inline && inline.getAttribute('data-overflow-template')) || '+__COUNT__';
  }

  function buildSwatchStyle(bg) {
    if (shared.buildSwatchStyle) return shared.buildSwatchStyle(bg);
    if (!bg) return 'border: solid 1px #000;';
    if (bg.indexOf('background-color:') === 0 || bg.indexOf('url(') === 0) {
      return bg + ' border: solid 1px #000;';
    }
    return 'background-color: ' + bg + '; border: solid 1px #000;';
  }

  function buildSwatchesHtml(group, currentHandle, overflowTemplate) {
    var swatchShape = (window.theme && window.theme.settings && window.theme.settings.swatch_shape) || 'round';
    var html =
      '<div class="product-swatches-options">' +
      '<ul class="product-swatches-options__list ff-body fs-body-50" data-lop-swatches-overflow-list data-overflow-template="' +
      escapeHtml(overflowTemplate) +
      '">';

    group.forEach(function (item) {
      // Products without a color mapping render as a blank circle and trigger
      // the overflow note ("+1" rectangle). Skip them.
      if (!item.swatchBg && !item.color) return;

      var isCurrent = item.handle === currentHandle;
      var colorLabel = item.color || item.title || '';
      var styleAttr = buildSwatchStyle(item.swatchBg);
      var commonAttrs =
        ' class="product-swatches-options__item product-swatches-options__item--swatch' +
        (isCurrent ? ' LOP-swatch-active' : '') +
        '" data-swatch-shape="' +
        escapeHtml(swatchShape) +
        '" style="' +
        escapeHtml(styleAttr) +
        '" aria-label="' +
        escapeHtml(colorLabel) +
        '"';

      if (isCurrent) {
        html += '<li' + commonAttrs + ' aria-current="true"></li>';
      } else {
        html +=
          '<button type="button"' +
          commonAttrs +
          ' data-lop-style-swatch data-style-swatch-handle="' +
          escapeHtml(item.handle) +
          '" title="' +
          escapeHtml(colorLabel) +
          '"></button>';
      }
    });

    html +=
      '<li class="product-swatches-options__item-overflow-note fs-body-25 lop-swatches-overflow-note" hidden aria-hidden="true"></li>' +
      '</ul></div>';

    return html;
  }

  function getMainProductImage(card) {
    var activeGallery = card.querySelector('.product-item__image--gallery.active img.image__img');
    if (activeGallery) return activeGallery;

    var images = card.querySelectorAll('.product-item__image-link .image__img, .product-item__image .image__img');
    for (var i = 0; i < images.length; i++) {
      var wrapper = images[i].closest('.product-item__image');
      if (wrapper && wrapper.classList.contains('product-item__image--two')) continue;
      return images[i];
    }

    return null;
  }

  function captureMediaState(card) {
    var carousel = card.querySelector('.product-item__media--lop-carousel');
    if (carousel) {
      var wrap = carousel.querySelector('.product-item__gallery-images-wrap');
      var bar = carousel.querySelector('.product-item__gallery-bar');
      return {
        type: 'carousel',
        galleryWrapHtml: wrap ? wrap.innerHTML : '',
        galleryBarHtml: bar ? bar.innerHTML : '',
      };
    }

    var secondWrapper = card.querySelector('.product-item__image--two');
    return {
      type: 'simple',
      secondImageHtml: secondWrapper ? secondWrapper.outerHTML : '',
      hasSecondImage: !!secondWrapper,
    };
  }

  function captureCardSnapshot(card) {
    var handle = card.getAttribute('data-product-handle') || card.getAttribute('data-handle');
    var img = getMainProductImage(card);
    var imageLink = card.querySelector('.product-item__image-link');
    var titleLink = card.querySelector('.product-item__product-title a');
    var priceEl = card.querySelector('.product-item__price');
    var variantInput = card.querySelector('.product-item__product-form-variant-input');
    var attributes = {};

    CARD_ATTRS.forEach(function (attr) {
      if (card.hasAttribute(attr)) {
        attributes[attr] = card.getAttribute(attr);
      }
    });

    return {
      handle: handle,
      media: captureMediaState(card),
      imageSrc: img ? img.getAttribute('src') || '' : '',
      imageSrcset: img ? img.getAttribute('srcset') || '' : '',
      imageSizes: img ? img.getAttribute('sizes') || '' : '',
      imageAlt: img ? img.getAttribute('alt') || '' : '',
      imageLinkHref: imageLink ? imageLink.href : '',
      imageLinkLabel: imageLink ? imageLink.getAttribute('aria-label') || '' : '',
      titleLinkHref: titleLink ? titleLink.href : '',
      titleText: titleLink ? titleLink.textContent : '',
      priceHtml: priceEl ? priceEl.innerHTML : '',
      variantId: variantInput ? variantInput.value : '',
      badges:
        window.LOPCollectionBadges && typeof window.LOPCollectionBadges.extractBadgesFromCard === 'function'
          ? window.LOPCollectionBadges.extractBadgesFromCard(card)
          : null,
      label:
        window.LOPCollectionBadges && typeof window.LOPCollectionBadges.extractLabelFromCard === 'function'
          ? window.LOPCollectionBadges.extractLabelFromCard(card)
          : null,
      attributes: attributes,
    };
  }

  function clearSwatchImageCache(card) {
    [
      'originalImageSrc',
      'originalImageSrcset',
      'originalImageSizes',
      'originalImageAlt',
      'originalSecondImageSrc',
      'originalSecondImageSrcset',
      'currentSecondImageUrl',
      'originalPriceHtml',
    ].forEach(function (key) {
      delete card.dataset[key];
    });
  }

  function buildGallerySlideHtml(src, alt, index, extraClass) {
    var cls = 'product-item__image--gallery' + (extraClass ? ' ' + extraClass : '');
    return (
      '<div class="' + cls + '" data-gallery-index="' + index + '">' +
      '<div class="image loaded">' +
      '<img class="image__img" src="' + escapeHtml(src) + '"' +
      ' alt="' + escapeHtml(alt) + '" loading="eager" fetchpriority="high">' +
      '</div></div>'
    );
  }

  function preloadImage(src) {
    if (!src) return;
    var img = new Image();
    img.src = src;
  }

  function applyMediaState(card, snap) {
    if (!snap.media) return false;

    if (snap.media.type === 'carousel') {
      // Full carousel snapshot — replace gallery HTML directly.
      var carousel = card.querySelector('.product-item__media--lop-carousel');
      if (!carousel) return false;

      var wrap = carousel.querySelector('.product-item__gallery-images-wrap');
      var bar = carousel.querySelector('.product-item__gallery-bar');
      if (wrap) wrap.innerHTML = snap.media.galleryWrapHtml;
      if (bar) bar.innerHTML = snap.media.galleryBarHtml;

      delete carousel.dataset.lopCarouselInit;
      document.dispatchEvent(
        new CustomEvent('lop:carousel-reinit', {
          detail: {
            media: carousel,
            variantId: snap.attributes['data-current-variant-id'] || snap.variantId || '',
          },
        })
      );
      return true;
    }

    // Non-carousel snapshot (embedded sibling not physically in the DOM).
    // Build a gallery from the embedded image data so the correct product is shown.
    var carouselEl = card.querySelector('.product-item__media--lop-carousel');
    if (carouselEl && snap.imageSrc) {
      var wrapEl = carouselEl.querySelector('.product-item__gallery-images-wrap');
      if (wrapEl) {
        // Pre-warm the browser cache so the image is already being fetched
        // before the DOM is rebuilt.
        preloadImage(snap.imageSrc);
        preloadImage(snap.imageSrc2);

        // Lock the gallery height to its current measured value before replacing
        // innerHTML. New <img> elements have no intrinsic size until they load,
        // which would briefly collapse the gallery and push swatches upward.
        // We release the lock once the first image fires its load/error event.
        var lockedHeight = wrapEl.offsetHeight || carouselEl.offsetHeight;
        if (lockedHeight > 0) {
          wrapEl.style.minHeight = lockedHeight + 'px';
          wrapEl.style.height = lockedHeight + 'px';
        }

        // Update the currently visible img src immediately so the new image
        // starts showing while the DOM is being rebuilt.
        var currentActiveImg = wrapEl.querySelector('.product-item__image--gallery.active img.image__img');
        if (currentActiveImg) {
          currentActiveImg.src = snap.imageSrc;
          currentActiveImg.alt = snap.imageAlt || '';
        }

        var slides = buildGallerySlideHtml(snap.imageSrc, snap.imageAlt || '', 0, 'active');
        if (snap.imageSrc2) {
          slides += buildGallerySlideHtml(snap.imageSrc2, snap.imageSrc2Alt || snap.imageAlt || '', 1, '');
        }
        wrapEl.innerHTML = slides;

        // Release the height lock once the first image loads (or errors),
        // so CSS aspect-ratio takes back control naturally.
        var firstNewImg = wrapEl.querySelector('img.image__img');
        var releaseHeightLock = function () {
          wrapEl.style.removeProperty('min-height');
          wrapEl.style.removeProperty('height');
        };
        if (firstNewImg) {
          if (firstNewImg.complete) {
            releaseHeightLock();
          } else {
            firstNewImg.addEventListener('load', releaseHeightLock, { once: true });
            firstNewImg.addEventListener('error', releaseHeightLock, { once: true });
          }
        }

        // Re-build bar segments to match the new slide count.
        var barEl = carouselEl.querySelector('.product-item__gallery-bar');
        if (barEl) {
          var segCount = snap.imageSrc2 ? 2 : 1;
          var barHtml = '';
          for (var s = 0; s < segCount; s++) {
            barHtml += '<button class="product-item__gallery-bar-segment' + (s === 0 ? ' active' : '') +
              '" data-gallery-index="' + s + '"' +
              (s === 0 ? ' aria-current="true"' : '') + '></button>';
          }
          barEl.innerHTML = barHtml;
        }

        delete carouselEl.dataset.lopCarouselInit;
        document.dispatchEvent(
          new CustomEvent('lop:carousel-reinit', {
            detail: {
              media: carouselEl,
              variantId: snap.attributes['data-current-variant-id'] || snap.variantId || '',
            },
          })
        );
      }
      return true;
    }

    // Plain card (no carousel) — handle optional second hover image.
    var imageLink = card.querySelector('.product-item__image-link');
    if (!imageLink) return false;

    var existingSecond = card.querySelector('.product-item__image--two');
    if (existingSecond) existingSecond.remove();

    if (snap.media.hasSecondImage && snap.media.secondImageHtml) {
      imageLink.insertAdjacentHTML('beforeend', snap.media.secondImageHtml);
      var secondWrapper = imageLink.querySelector('.product-item__image--two');
      if (secondWrapper) secondWrapper.classList.remove('active');
    }

    return false;
  }

  function ensureSnapshot(card) {
    var handle = card.getAttribute('data-product-handle') || card.getAttribute('data-handle');
    if (!handle) return null;

    productSnapshots[handle] = captureCardSnapshot(card);
    return productSnapshots[handle];
  }

  function getDisplayedHandle(card) {
    return (
      card.getAttribute('data-lop-style-display-handle') ||
      card.getAttribute('data-product-handle') ||
      card.getAttribute('data-handle')
    );
  }

  function findGroupItem(styleId, handle) {
    var group = styleGroups[styleId];
    if (!group) return null;

    for (var i = 0; i < group.length; i++) {
      if (group[i].handle === handle) return group[i];
    }

    return null;
  }

  function applyStyleToCard(card, target, group) {
    var snap = target.snapshot;
    if (!snap) return;

    CARD_ATTRS.forEach(function (attr) {
      if (snap.attributes[attr]) {
        card.setAttribute(attr, snap.attributes[attr]);
      } else {
        card.removeAttribute(attr);
      }
    });

    card.setAttribute('data-lop-style-display-handle', target.handle);
    clearSwatchImageCache(card);

    var carouselApplied = applyMediaState(card, snap);

    if (!carouselApplied) {
      var targetImg = getMainProductImage(card);

      if (targetImg && snap.imageSrc) {
        targetImg.src = snap.imageSrc;
        if (snap.imageSrcset) {
          targetImg.srcset = snap.imageSrcset;
        } else {
          targetImg.removeAttribute('srcset');
        }
        if (snap.imageSizes) {
          targetImg.sizes = snap.imageSizes;
        } else {
          targetImg.removeAttribute('sizes');
        }
        targetImg.alt = snap.imageAlt;
        var imageWrapper = targetImg.closest('.image');
        if (imageWrapper) {
          imageWrapper.classList.add('loaded');
        }
      }
    }

    var cardImageLink = card.querySelector('.product-item__image-link');
    if (cardImageLink && snap.imageLinkHref) {
      cardImageLink.href = snap.imageLinkHref;
      if (snap.imageLinkLabel) {
        cardImageLink.setAttribute('aria-label', snap.imageLinkLabel);
      }
    }

    var cardTitleLink = card.querySelector('.product-item__product-title a');
    if (cardTitleLink) {
      if (snap.titleLinkHref) cardTitleLink.href = snap.titleLinkHref;
      if (snap.titleText) cardTitleLink.textContent = snap.titleText;
    }

    var cardPrice = card.querySelector('.product-item__price');
    if (cardPrice) {
      cardPrice.innerHTML = snap.priceHtml;
    }

    if (window.LOPCollectionBadges && typeof window.LOPCollectionBadges.syncProductItem === 'function') {
      window.LOPCollectionBadges.syncProductItem(card, snap.badges || null, snap.label || null);
    }

    var cardVariantInputs = card.querySelectorAll('.product-item__product-form-variant-input');
    if (snap.variantId && cardVariantInputs.length) {
      cardVariantInputs.forEach(function (input) {
        input.value = snap.variantId;
      });
    }

    var container = card.querySelector('.product-item-related-style');
    if (container) {
      container.innerHTML = buildSwatchesHtml(group, target.handle, getOverflowTemplate(card));
      document.dispatchEvent(
        new CustomEvent('lop:style-swatches-rendered', {
          detail: { root: card },
        })
      );
    }

    if (window.LOPMemorialDaySale && typeof window.LOPMemorialDaySale.sync === 'function') {
      window.LOPMemorialDaySale.sync(card);
    }
  }

  function handleStyleSwatchClick(event) {
    var swatch = event.target.closest('[data-lop-style-swatch]');
    if (!swatch) return;

    var card = swatch.closest('.product-item[data-style-id]');
    if (!card) return;

    event.preventDefault();
    event.stopPropagation();

    var handle = swatch.getAttribute('data-style-swatch-handle');
    var styleId = card.getAttribute('data-style-id');
    if (!handle || !styleId || !styleGroups[styleId]) return;

    if (handle === getDisplayedHandle(card)) return;

    var target = findGroupItem(styleId, handle);
    if (!target) return;

    applyStyleToCard(card, target, styleGroups[styleId]);
  }

  function registerCard(card, idMap) {
    var styleId = card.getAttribute('data-style-id');
    if (!styleId) return;

    var handle = card.getAttribute('data-product-handle') || card.getAttribute('data-handle');
    if (!handle) return;

    ensureSnapshot(card);

    if (!idMap[styleId]) {
      idMap[styleId] = {};
    }

    if (!idMap[styleId][handle]) {
      var embeddedSortIndex = getSortIndexFromEmbedded(card, handle);

      idMap[styleId][handle] = {
        handle: handle,
        image: card.getAttribute('data-product-image'),
        url: card.getAttribute('data-product-url'),
        title: card.getAttribute('data-product-title'),
        color: card.getAttribute('data-product-color'),
        swatchBg: card.getAttribute('data-swatch-bg'),
        sortIndex: embeddedSortIndex,
        snapshot: productSnapshots[handle],
        embedded: false,
      };
    } else {
      idMap[styleId][handle].image = card.getAttribute('data-product-image') || idMap[styleId][handle].image;
      idMap[styleId][handle].url = card.getAttribute('data-product-url') || idMap[styleId][handle].url;
      idMap[styleId][handle].title = card.getAttribute('data-product-title') || idMap[styleId][handle].title;
      idMap[styleId][handle].color = card.getAttribute('data-product-color') || idMap[styleId][handle].color;
      idMap[styleId][handle].swatchBg = card.getAttribute('data-swatch-bg') || idMap[styleId][handle].swatchBg;
      idMap[styleId][handle].snapshot = productSnapshots[handle];
      if (typeof idMap[styleId][handle].sortIndex !== 'number') {
        var cardSortIndex = getSortIndexFromEmbedded(card, handle);
        if (typeof cardSortIndex === 'number') {
          idMap[styleId][handle].sortIndex = cardSortIndex;
        }
      }
      idMap[styleId][handle].embedded = false;
    }
  }

  function init(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('.product-item[data-style-id]');
    if (!cards.length) return;

    var idMap = {};

    cards.forEach(function (card) {
      registerEmbeddedSiblings(card, idMap);
      registerCard(card, idMap);
    });

    Object.keys(idMap).forEach(function (styleId) {
      var groupMap = idMap[styleId];
      styleGroups[styleId] = sortGroupByHandle(
        Object.keys(groupMap).map(function (handle) {
          return groupMap[handle];
        })
      );

      var group = styleGroups[styleId];
      if (group.length < 1) return;

      // Build swatches on every DOM card for this styleId.
      // Each color product shows as its own card; swatches on each card
      // display the full style group so users can see and switch to any color.
      cards.forEach(function (card) {
        if (card.getAttribute('data-style-id') !== styleId) return;

        // Restore any card that was previously hidden by old dedup logic.
        if (card.getAttribute('data-lop-style-duplicate') === 'true') {
          card.removeAttribute('data-lop-style-duplicate');
          card.style.display = '';
        }

        var container = card.querySelector('.product-item-related-style');
        if (!container) return;
        if (container.getAttribute('data-style-swatches-built') === 'true') return;

        var currentHandle = getDisplayedHandle(card);
        container.innerHTML = buildSwatchesHtml(group, currentHandle, getOverflowTemplate(card));
        container.setAttribute('data-style-swatches-built', 'true');

        document.dispatchEvent(
          new CustomEvent('lop:style-swatches-rendered', {
            detail: { root: card },
          })
        );
      });
    });
  }

  document.addEventListener('click', handleStyleSwatchClick, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      var hasNewCards = false;

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.product-item[data-style-id]')) {
            hasNewCards = true;
            return;
          }
          if (node.querySelector && node.querySelector('.product-item[data-style-id]')) {
            hasNewCards = true;
          }
        });
      });

      if (hasNewCards) init();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
